module.exports = __webpack_public_path__ + "img/03mazda-miata.48c5c3b1.png";